import { VerrichtingenEntitySchema } from '@ksyos/http';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const verrichtingenContract = c.router({
    getVerrichtingen: {
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'GET',
        path: `/api/v2/patient/verrichtingen`,
        query: z.object({
            serviceGroupName: z.string().optional(),
        }),
        responses: {
            200: VerrichtingenEntitySchema,
        },
        summary: 'Get the verrichtingen for a patient',
    },
});
